import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 7h-1V6c0-2.761-2.239-5-5-5S5 3.239 5 6v1H4c-.552 0-1 .448-1 1v10c0 .552.448 1 1 1h12c.552 0 1-.448 1-1V8c0-.552-.448-1-1-1zM6 6c0-2.209 1.791-4 4-4s4 1.791 4 4v1H6V6zm10 12H4V8h12v10z',
  ],
  height: 20,
  width: 20,
});
